import EmptyListMessage from '@components/common/EmptyListMessage';
import CountryModal from '@moncler/components/countryselector/CountryModal';
import { OrdersActionTypes } from '@state/features/common.types';
import { getOrdersHistory, getReturnableOrders } from '@state/features/orders.selectors';
import analytics from '@utils/analytics';
import { calculateDateforJP } from '@utils/stringUtils';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
const OrdersListForReturn = (props) => {
    const { t } = useTranslation();
    const { orders, loading } = useSelector(props.onlyreturnable ? getReturnableOrders : getOrdersHistory);
    const dispatch = useDispatch();
    useEffect(() => {
        if (loading) {
            dispatch({
                type: OrdersActionTypes.FETCH_ORDERS,
            });
        }
    }, []);
    function getOrders() {
        if (!orders) {
            return [];
        }
        if (props.onlyEligibleForExchange) {
            return orders.filter((o) => o.isEligibleForExchange || o.isEligibleForReturnInDifferentCountry);
        }
        return orders;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "orderlisting" }, !loading && (React.createElement(React.Fragment, null, getOrders().length > 0 ? (React.createElement(React.Fragment, null, getOrders().map((order) => (React.createElement("button", { key: order.orderNumber, type: "button", onClick: () => !order.isEligibleForReturnInDifferentCountry && props.callback(order), className: classNames('orderlisting-item', { 'orderlisting-item__selected': props.orderNumberActive === order.orderNumber }) },
            React.createElement("div", { className: "orders-listing__order-detail" },
                React.createElement("div", { className: "order-detail__column" },
                    React.createElement("h2", null,
                        React.createElement("span", { className: "dt" }, t('orderhistory.ordernumber')),
                        React.createElement("span", { className: "dd" }, order.orderNumber))),
                React.createElement("p", { className: "order-detail__column" },
                    React.createElement("span", { className: "dt" }, t('label.date')),
                    React.createElement("span", { className: "dd" }, calculateDateforJP(order.creationDate))),
                React.createElement("p", { className: "order-detail__column" },
                    React.createElement("span", { className: "dt" }, t('order.statuslabel')),
                    React.createElement("span", { className: "dd" }, order.orderStatus.displayValue.charAt(0).toUpperCase() + order.orderStatus.displayValue.toLowerCase().slice(1)))),
            (props.onlyEligibleForExchange || props.onlyreturnable) && order.isEligibleForReturnInDifferentCountry && (React.createElement("div", { className: "orderlisting-item__errormessage" },
                React.createElement(CountryModal, null, t('return.differentcountry'))))))))) : (React.createElement(EmptyListMessage, { buttonLink: window.homeurl, buttonText: t('button.backtoshopping'), className: ` orders-history__empty-message`, text: t('orderhistory.emptyList'), pushAnalytics: () => analytics.ordersTwo() })))))));
};
export default OrdersListForReturn;
